import { DataGrid, GridToolbarQuickFilter } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import React, { useState } from "react";
import { useDispatch, useSelector } from 'react-redux'
import { obtenerInventarios, historialComprasFolios, historialEntregasHologramas } from '../../../../redux/DuckPanelHologramas/ModuloInventarioDuck';
import { v4 as uuidv4 } from 'uuid';
import Button from '@mui/material/Button'
import { ThemeProvider, createTheme } from '@mui/material/styles';

const PanelInventarioComponent = () => {

    const dispatch = useDispatch()
    const inventarios = useSelector(store => store.ModuloInventario.data)

    React.useEffect(async () => {
        await dispatch(obtenerInventarios())
    }, [])

    const columns = [
        { field: 'numAsociado', headerName: 'Número de asociado', headerAlign: 'center', width: 200 },
        { field: 'razonSocial', headerName: 'Razón social', headerAlign: 'center', width: 550 },
        { field: 'invMezcal', headerName: 'Inventario mezcal', headerAlign: 'center', width: 220 },
        { field: 'invBebidasMezcal', headerName: 'Inventario bebidas con mezcal', headerAlign: 'center', width: 250 },
    ]

    const rows = []

    inventarios?.map(anexo => {
        let hologramasmezcal = ''
        if (anexo?.hologramasmezcal != '') hologramasmezcal = anexo?.hologramasmezcal
        else hologramasmezcal = '0'
        let hologramasbebidas = ''
        if (anexo?.hologramasbebidas != '') hologramasbebidas = anexo?.hologramasbebidas
        else hologramasbebidas = '0'
        rows.push({
            id: uuidv4(), numAsociado: anexo?.cliente?.numerosocio, razonSocial: anexo?.cliente?.nombrerazonsocial,
            invMezcal: hologramasmezcal, invBebidasMezcal: hologramasbebidas, idloginfc40_solicitudadquisicionholo: anexo?.cliente?.idlogin
        })
    })

    const theme = createTheme({
        palette: {
            primary: {
                main: "#7D9A47"
            },
            secondary: {
                main: "#DC3545"
            }
        },
        typography: {
            fontFamily: "Montserrat",
            textTransform: 'none',
            button: {
                fontSize: 16,
                fontWeight: 500,
                fontFamily: "Montserrat",
                textTransform: 'none'
            }
        }
    });

    function QuickSearchToolbar() {
        return (
            <Box
                sx={{
                    p: 0.5,
                    pb: 0,
                    mb: 2,
                    textAlign: 'left',
                    height: 30,
                    width: '100%',
                    backgroundColor: 'white'
                }}>
                <ThemeProvider theme={theme}>
                    <GridToolbarQuickFilter style={{ backgroundColor: '#F4F6F6', width: '100%', fontFamily: 'Montserrat' }} placeholder='Búsqueda...' />
                </ThemeProvider>
            </Box>
        );
    }

    return (
        <div className="container" style={{ padding: 0 }}>
            <Box sx={{ height: 530, width: '100%'}}>
                <DataGrid
                    rows={rows}
                    columns={columns}
                    disableColumnMenu={true}
                    components={{ Toolbar: QuickSearchToolbar }}
                    pageSize={10}
                    getRowHeight={() => 'auto'}
                    sx={{
                        boxShadow: 0,
                        color: 'black',
                        border: 0,
                        backgroundColor: 'white',
                        fontFamily: 'Montserrat',
                        '& .MuiDataGrid-cell': {
                            display: 'block',
                            position: 'relative',
                            textAlign: 'center',
                            paddingTop: '15px',
                            paddingBottom: '15px',
                            paddingLeft: 0,
                            paddingRight: 0
                        },
                        '& .MuiDataGrid-columnHeaders': {
                            backgroundColor: '#0C365A',
                            color: 'white',
                            fontFamily: 'Montserrat',
                            fontWeight: 'bold',
                            height: '20px'
                        }
                    }}
                />
            </Box>
        </div>
    );

};
export default PanelInventarioComponent